// extracted by mini-css-extract-plugin
module.exports = {"recommend":"_16548","hd":"_1430","icon":"_6674","title":"_10820","list":"_5900"};